jQuery(function () {
    const $smbwrap = $('.smb-gc-form-wrap');
    const $smbplansTable = $('#smb-plans-table');

    $smbwrap.on('focus', 'input', (e) => {
        $smbwrap.find('input').removeClass('focus');
        $smbwrap.addClass('input-focus');
        $(e.target).parent().addClass('focus');
    });

    $smbwrap.on('blur', 'input', () => {
        $smbwrap.find('input').parent().removeClass('focus');
        $smbwrap.removeClass('input-focus');
    });

    $('.smb-contact-phone').on('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBPhoneClick',
        });
    });

    $('.smb-contact-email').on('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBEmailClick',
        });
    });

    $('.smb-contact-btn').on('click', function(e) {
        e.preventDefault();
        let pageUrl = $(e.target).attr('href');
        let pkgAddons = window.Cookies.get('package-addons');
        let fiberResult = window.Cookies.get('smbfibersearchresult');
        let packageData = $.parseJSON(window.Cookies.get('package-data'));
        let packageName = packageData.package_name;
        let packageCost = packageData.package_cost;
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBHeaderContactCTA',
            'ccFiber' : fiberResult,
            'ccName' : packageName,
            'ccPrice' : packageCost,
            'ccAddons' : pkgAddons
        });

        window.location.href = pageUrl;

    });

    $('#show-plans-table').on('click', () => {

        let fiberResult = window.Cookies.get('smbfibersearchresult');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBSeeAllButton',
            'ccFiber' : fiberResult
        });

        const $me = $('#show-plans-table');
        $me.toggleClass('show-table');
        $smbplansTable.toggleClass('show');
    });

    $('.smb-addon-readmore').on('click', (e) => {
        e.preventDefault();
        const $me = $(e.target).parent();
        const addonName = $me.attr('data-addonname');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBReadMoreAddOn',
            'ccAddons' : addonName
        });
        
        $me.toggleClass('smb-minimize');
        const readmore = $me.attr('data-readmore');
        $(`#${readmore}`).toggleClass('show-less');
    });


    $('.addon-toggle-switch').on('change', (e) => {
        const toggleTarget = $($(e.target).data('toggle'));
        const addonName = $(e.target).data('addonname');
        const addonPosition = $(e.target).data('addonpos');
        const isChecked = $(e.target).is(':checked');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBTogglAddOn',
            'ccAddons' : addonName,
            'ccPosition' : addonPosition
        });


        if (!isChecked && toggleTarget.hasClass('show')) {
            toggleTarget.removeClass('show');
        }

        if (isChecked && !toggleTarget.hasClass('show')) {
            toggleTarget.addClass('show');
        }

        let pa = ''
        $('.smb-expand').children('p').each(function () {
            if($(this).hasClass('show')) {
                if(pa == '') {
                    pa = pa + $(this).data('pkgaddon');
                } else {
                    pa = pa + ',' +$(this).data('pkgaddon');
                }
            }
        });
        if($("input[name=package_addons]").length > 0) {
            window.Cookies.set("package-addons", pa);
            $("input[name=package_addons]").val(pa).trigger("change");
        }
    });

    /** newsearch */
    $('#newSearchBtn, #smbBackBtn').on('click', (e) => {
        e.preventDefault();

        let fiberResult = window.Cookies.get('smbfibersearchresult');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBNewSearch',
            'ccFiber' : fiberResult
        });
        let searchPageUrl = window.Cookies.get('smb-search-page');
        if(searchPageUrl) {
            window.location.href = searchPageUrl;
        }
        else {
            return false;
        }
    });

    /** set package details */
    $('.buy-plan-btn').on('click', (e) => {
        e.preventDefault();
        let pkgUrl = $(e.target).data('packageurl');
        let pkgName = $(e.target).data('packagename');
        let pkgCost = $(e.target).data('packagecost');
        let pkgPosition = $(e.target).data('position');
        let fiberResult = window.Cookies.get('smbfibersearchresult');

        pkgCost = pkgCost.replace(/[^\d.-]/g,'.').replace(/[.](?!\d*$)/g,'');
        pkgCost = parseFloat(pkgCost);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBChoosePackage',
            'ccFiber' : fiberResult,
            'ccName' : pkgName,
            'ccPrice' : pkgCost,
            'ccPosition' : pkgPosition
        });

        window.Cookies.set("package-data", JSON.stringify({'package_name':pkgName, 'package_cost':pkgCost, 'package_position':pkgPosition}) );
        window.location.href = pkgUrl;
    });

    /** set package read more */
    $('.smb-readmore-btn').on('click', (e) => {
        e.preventDefault();
        let pkgUrl = $(e.target).attr('href');
        let pkgName = $(e.target).data('packagename');
        let pkgCost = $(e.target).data('packagecost');
        let pkgPosition = $(e.target).data('position');
        let fiberResult = window.Cookies.get('smbfibersearchresult');

        pkgCost = pkgCost.replace(/[^\d.-]/g,'.').replace(/[.](?!\d*$)/g,'');
        pkgCost = parseFloat(pkgCost);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBReadMoreButton',
            'ccFiber' : fiberResult,
            'ccName' : pkgName,
            'ccPrice' : pkgCost,
            'ccPosition' : pkgPosition
        });

        window.Cookies.set("package-data", JSON.stringify({'package_name':pkgName, 'package_cost':pkgCost}) );
        window.location.href = pkgUrl;
    });
    

    // SEARCH
    let selected = {
        id: null,
        company: null,
        address: null,
    };
    const companiesData = {};

    let companyHits = [];
    let addressHits = [];

       
    const smbForm = $('.smb-gc-form');
    const companyField = $('.smb-gc-form .form-field-group.company input');
    const companyAutocompleteResult = $('.smb-gc-form .form-field-group.company .result-dropdown');
    const companyAutocompleteResultList = $('.smb-gc-form .form-field-group.company .result-dropdown > div');
    const addressField = $('.smb-gc-form .form-field-group.address input');
    const addressAutocompleteResult = $('.smb-gc-form .form-field-group.address .result-dropdown');
    const addressAutocompleteResultList = $('.smb-gc-form .form-field-group.address .result-dropdown > div');
    const submitButton = $('.smb-gc-form .smb-submit-btn');
    const errorMessage = $('.smb-gc-form-wrap .error-message');
    const companyId = $('#companyId');
    const addressId = $('#addressId');


    $(window).on('load', function() {
        if( smbForm.length ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'ccSMBSearchView'
            });
        }

        if( $('.plan-timeline--line').length > 0 ) {
            let packageData = $.parseJSON(window.Cookies.get('package-data'));
            let pkgName = packageData.package_name;
            let pkgCost = packageData.package_cost;
            let fiberResult = window.Cookies.get('smbfibersearchresult');

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'ccSMBCheckoutPage',
                'ccFiber' : fiberResult,
                'ccName' : pkgName,
                'ccPrice' : pkgCost
            });
        }

    }); 

    companyField.on('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBSearchFieldClick'
        });
    });

    addressField.on('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBSearchFieldClick'
        });
    });

    function enableSubmitBtn() {

        let enableFlag = true;

        if (companyId.val() == '' ) {
            enableFlag = false;
        }

        if (addressId.val() == '') {
            enableFlag = false;
        }

        if (enableFlag) {
            $('.smb-submit-btn').removeClass('disable-state');
        }
    }

    function companyFieldErrorCheck() {
        let errorFlag = false;
        let error = '';
        if (companyId.val() == '') {
            error = companyField.data('error');
            companyField.parent().addClass('error');
            errorFlag = true;
        }

        if(errorFlag) {
            if (companyField.parent().hasClass('error')) {
                return true;
            } else {
                companyField.parent().addClass('error');
            }
            errorMessage.html(error);
        } else {
            if (companyField.parent().hasClass('error')) {
                companyField.parent().removeClass('error');
            }
            let errorFlag = false;
            errorMessage.empty();
        }
    }

    function addressFieldErrorCheck() {
        let errorFlag = false;
        let error = '';
        if (addressId.val() == '') {
            error = addressField.data('error');
            addressField.parent().addClass('error');
            errorFlag = true;
        }

        if(errorFlag) {
            if (addressField.parent().hasClass('error')) {
                return true;
            } else {
                companaddressFieldyField.parent().addClass('error');
            }
            errorMessage.html(error);
        } else {
            if (addressField.parent().hasClass('error')) {
                addressField.parent().removeClass('error');
            }
            errorMessage.empty();
            let errorFlag = false;
        }
    }
    companyField.blur(function() {
        enableSubmitBtn();
        companyFieldErrorCheck();
    });

    addressField.blur(function() {
        enableSubmitBtn();
        addressFieldErrorCheck();
    });

    if( smbForm.length ) {
        window.Cookies.set("address-data", '');
        window.Cookies.set("company-data", '');
        window.Cookies.set("package-addons", '');
        window.Cookies.set("package-data", '');
        window.Cookies.set("smbfibersearchresult", '');
    }
    const cancelAutoCompleteDropdown = () => {
        if(companyAutocompleteResult.hasClass('show')) {
            companyAutocompleteResult.removeClass('show');
        }
        if(addressAutocompleteResult.hasClass('show')) {
            addressAutocompleteResult.removeClass('show');
        }
    }

    $(document).on('click', (e) => {
        if (!smbForm.has(e.target).length) {
            cancelAutoCompleteDropdown();
        }
    });

    smbForm.on('submit', (e) => {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'ccSMBSearchSubmitButton'
        });

        let errorFlag = false;
        companyField.parent().removeClass('error');
        addressField.parent().removeClass('error');
        window.Cookies.set("smb-search-page", window.location.href);

        if (companyField.val().length < 2 || companyId.val() == '') {
            error = companyField.data('error');
            companyField.parent().addClass('error');
            errorFlag = true;
        }

        if (addressField.val().length < 2 || addressId.val() == '') {
            error = addressField.data('error');
            addressField.parent().addClass('error');
            errorFlag = true;
        }
        
        if(errorFlag) {
            if(!$('.smb-submit-btn').hasClass('disable-state')) {
                $('.smb-submit-btn').addClass('disable-state');
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'ccSMBSearchErrorMessage'
            });
            errorMessage.html(error);
            e.preventDefault();
        } else {
            $('.smb-submit-btn').removeClass('disable-state');
            window.Cookies.set("smb-datalayer-flag", Math.random().toString(36).slice(-5));
        }
    });

    companyField.on('input', () => {
        const input = companyField.val().toLowerCase();

        companyHits = [];
        if (input.length > 0) {
            let url = "/wp-json/api/v1/business_search?query="+input;
            $.ajax({
                type: 'post',
                url: url,
                success: function (data) {
                    companyAutocompleteResultList.empty();
                    let companyHits = data;
                    if (companyHits.length > 0) {     
                        let tabIndex = '1001';      
                        for (const company of companyHits) {
                            companyAutocompleteResultList.append(`<a href='#' data-orgno='${company.orgNr}' data-companyid='${company.companyId}' tabindex="${tabIndex}">${company.businessName}</a>`);
                            tabIndex++;
                        }
                        if(!companyAutocompleteResult.hasClass('show')) {
                            companyAutocompleteResult.addClass('show');
                        }
                    } else {
                        companyAutocompleteResult.removeClass('show');
                    }
                }
            });
        }
        
    });

    companyField.on('click', (e) => {
        e.stopPropagation();
    });

    companyField.on('focus', () => {
        if (companyHits && companyHits.length > 0) {
            companyAutocompleteResult.addClass('show');
        }
        addressAutocompleteResult.removeClass('show');
        return false;
    });

    companyAutocompleteResultList.on('click', 'a', (e) => {
        e.preventDefault();
        e.stopPropagation();
    
        const company_id = $(e.target).data('companyid');
        const org_num = $(e.target).data('orgno');
        const company_name = $(e.target).text();
       
        companyField.val(company_name);
        $('#companyId').val(company_id);

        enableSubmitBtn();
        companyFieldErrorCheck();

        window.Cookies.set("company-data", JSON.stringify({'org_number':org_num, 'company_name':company_name, 'company_id': company_id}) );
        addressField.focus();
    });



    const onAddressFieldActivity = () => {
        companyAutocompleteResult.removeClass('show');
        const input = addressField.val().toLowerCase();

        addressHits = [];

        if (input.length > 0) {
            let url = "/wp-json/api/v1/newaddress_search?query="+input;
            $.ajax({
                type: 'post',
                url: url,
                success: function (data) {
                    addressAutocompleteResultList.empty();
                    let addressHits = data;
                    if (addressHits.length > 0) {     
                        let tabIndex = '1101';      
                        for (const address of addressHits) {
                            let fulladdress = `${address.address_text}`;          
                            addressAutocompleteResultList.append(`<a href="#" data-address="${fulladdress}" data-addressid="${address.addressId}" tabindex="${tabIndex}">${fulladdress}</a>`);
                            tabIndex++;
                        }
                        if(!addressAutocompleteResult.hasClass('show')) {
                            addressAutocompleteResult.addClass('show');
                        }
                    } else {
                        addressAutocompleteResult.removeClass('show');
                    }
                }
            });
        }
        
    };


    addressField.on('input', onAddressFieldActivity);
    addressField.on('focus', onAddressFieldActivity);

    addressAutocompleteResultList.on('click', 'a', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const address = $(e.target).data('address');
        const addressId = $(e.target).data('addressid');
        addressField.val(address);
        $('#addressId').val(addressId);

        enableSubmitBtn();
        addressFieldErrorCheck();

        window.Cookies.set("address-data", JSON.stringify({'address_txt':address, 'address_id': addressId}) );
        addressAutocompleteResult.removeClass('show');
        submitButton.focus();
    });
});